import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { DtpContentContainer } from 'dtp-react-components';
import { Grid, Input, DataGrid, Button } from '../../components/index';
import { doPut, salvarListaMensagens, trataMensagemSucesso } from '../../utils/requests';

class Mensagem extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = (chave, event) => {
    const listaMensagemAlterada = this.props.listaMensagens
      .map((m) => {
        const mensagemAlterada = Object.assign({}, m);
        if (mensagemAlterada.chave === chave) {
          mensagemAlterada.valor = event.value;
        }

        return mensagemAlterada;
      });

    salvarListaMensagens(listaMensagemAlterada);
  }

  atualizarMensagens = () => {
    doPut(
      'config/frontend/',
      { listaMensagens: this.props.listaMensagens },
      this.trataSucesso,
    );
  }

  trataSucesso = () => {
    trataMensagemSucesso(['Mensagem atualizado.']);
  }

  renderRows = () => {
    const listaMensagensAtual = _.orderBy(this.props.listaMensagens || [], ['id'], ['desc']);
    return (
      listaMensagensAtual.map(m => (
        <Input
          maxlength="255"
          label={`${m.descricao} (${m.chave})`}
          value={m.valor}
          onChange={e => this.handleChange(m.chave, e)}
        />
      ))
    );
  }

  render() {
    return (
      <DtpContentContainer>
        <DataGrid title="Configuração de Mensagens do Sistema" icon="ico-doc-pencil" >
          <Grid cols="12 12 12 12">
            {this.renderRows()}
            <Button
              className="dtp-primary right"
              title="Alterar"
              onClick={this.atualizarMensagens}
              hint="Alterar mensagens"
            />
          </Grid>
        </DataGrid>
      </DtpContentContainer>
    );
  }
}

Mensagem.propTypes = {
  listaMensagens: PropTypes.arrayOf({
    id: PropTypes.string,
    chave: PropTypes.string,
    valor: PropTypes.string,
  }).isRequired,
};

const mapStateToProps = state => ({
  listaMensagens: state.base.listaMensagens,
});

export default connect(mapStateToProps)(Mensagem);



// WEBPACK FOOTER //
// ./src/pages/mensagens/Mensagens.jsx